import DOMPurify from 'dompurify';

export function sanitizeSvgFile(file, onSafe, onUnsafe) {
    if (file.type !== "image/svg+xml") {
        onSafe(file);
        return;
    }
    const reader = new FileReader();
    reader.onload = (e) => {
        const sanitizedSVG = DOMPurify.sanitize(e.target.result, { USE_PROFILES: { svg: true } });
        if (sanitizedSVG.includes('<script') || /on\w+=/i.test(sanitizedSVG)) {
            onUnsafe("SVG contains unsafe code.");
        } else {
            onSafe(file);
        }
    };
    reader.readAsText(file);
};
export const getSafeHtmlFromDb = (userInputFromDb) => {
    return DOMPurify.sanitize(userInputFromDb, { ADD_ATTR: ['target'] });
}